var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgReveal = function SvgReveal(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 12.48",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 10a3.756 3.756 0 1 1 2.66-1.1A3.76 3.76 0 0 1 10 10m0-10C3.76 0 0 6.24 0 6.24s3.76 6.24 10 6.24 10-6.24 10-6.24S16.24 0 10 0m0 3.732a2.1 2.1 0 0 0-.719.133A1.21 1.21 0 0 1 10 4.984a1.253 1.253 0 0 1-1.254 1.254 1.21 1.21 0 0 1-1.119-.719 2.3 2.3 0 0 0-.133.719A2.506 2.506 0 1 0 10 3.732"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgReveal);
export default ForwardRef;